import { FilterObject } from 'app/filter.utils'
import { OptionType } from 'types/OptionType'
import { useBaseFilter } from 'app/components/base-filter/useBaseFilter'
import { BaseFilterComponent } from 'app/components/base-filter/BaseFilterComponent'

interface BaseFilterProps {
  attribute: string
  displayName: string
  icon: React.ReactElement
  /** See BaseFilterComponent. */
  shortName?: string
  queryURL?: string
  fetcher?: (params: { query: string; [key: string]: any }) => Promise<any>
  preAppliedValues?: string | string[]
  customSearchParam: string
  defaultFilters?: FilterObject[]
  optionsMapper: (res: any) => OptionType[]
}

export default function BaseFilter({
  attribute,
  displayName,
  icon,
  shortName,
  queryURL,
  fetcher,
  preAppliedValues,
  customSearchParam,
  defaultFilters,
  optionsMapper,
}: BaseFilterProps) {
  const props = useBaseFilter({
    attribute,
    displayName,
    queryURL,
    fetcher,
    preAppliedValues,
    customSearchParam,
    defaultFilters,
  })
  return <BaseFilterComponent {...props} icon={icon} shortName={shortName} optionsMapper={optionsMapper} />
}
